import { createFileRoute } from "@tanstack/react-router"
import DesignSystemPages from "~/pages/design-system/pages/Pages"

export const Route = createFileRoute("/_auth/internal/design-system/pages/pages")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemPages />
}
